import React, { useContext } from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import NearbyExperiencesModal from 'tripPlanner/components/TripModal/ViewMoreOffers/NearbyExperiencesModal'

interface Props {
  lat: number
  lng: number
  tripId: string
  showSearch: boolean
  className?: string
}

function ViewNearbyExperiencesCta({
  lat,
  lng,
  tripId,
  showSearch,
  className,
}: Props) {
  const showModal = useContext(ModalContext)

  return (
    <TextButton
      kind="secondary"
      size="medium"
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showModal(
          <NearbyExperiencesModal
            lat={lat}
            lng={lng}
            tripId={tripId}
            showSearch={showSearch}
          />,
        )
      }}
    >
      View more offers
    </TextButton>
  )
}

export default ViewNearbyExperiencesCta
